import React, { Children } from "react";
import PropTypes from "prop-types";
import { Checkbox } from "antd";
import "./styles/rounded-checkbox.css";

const RoundedCheckbox = (props) => {
  const { checked, onChange, disabled, children } = props;
  return (
    <Checkbox
      className="rounded_check_box"
      style={{ borderRadius: "50%" }}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
    >
      {children}
    </Checkbox>
  );
};

RoundedCheckbox.defaultProps = {
  onChange: () => {},
  disabled: false,
  children: null,
};

RoundedCheckbox.propTypes = {
  checked: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]).isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default RoundedCheckbox;
